import { Box, Button, Grid, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { AnswerProps } from "./types"
import { useTranslation } from "react-i18next"
import { ActionDrawer } from "../../../../../../components/ActionDrawer"
import EvidenceDetail from "../../../../../actionPlans/pages/form/components/evidenceDetail"
import { useEvidences } from "../../../../../../hooks/evidences/useEvidences"
import { Actions } from "../actions"
import { CSSProperties } from "react"
import { AnswerAction } from "../actions/enum"
import { useNavigate, useParams } from "react-router-dom"
import { actions, navigateOption } from "./contants"
import { SnackSimple } from "../../../../../../components"
import { useEvidenceDownload } from "../../hooks"


const Answer = ({ correctOption, title, haveConfig, selected, iconUrl, idExecute, score, action, evidence, isMultiple, header, placeholder, ids, navigateType, isCatalog, fullAnswer }: AnswerProps) => {
    const { id: scheduleId } = useParams()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const styles = useStyles()
    const { evidences, existEvidences, } = useEvidences({ evidencesResponse: evidence || [] })
    const goReportFolioOrActionPlan = ({ name, id }: { name: 'action-plan' | 'report-folio' | 'recurrence', id?: string }) => {
        const navigationType = navigateOption[navigateType]
        let nav = `${navigationType.reportFolio}`
        if (name == 'action-plan') { nav = `${navigationType.actionPlan}/${id}` }
        if (name == 'recurrence') { nav = `${navigationType.recurrence}/${id}` }
        navigate(`${nav}?${navigationType.navigate.replaceAll('{id}', scheduleId ?? '')}&${actions}&id=${id}`, {
            state: {
                type: navigateType,
                ...header,
                id: scheduleId,
                replaceRoutes: {
                    schedule_state: {
                        state: {
                            id: idExecute
                        }
                    }
                }
            }
        })
    }

    const { disable, openSnackbar, handleCloseSnackbar, downloadEvidences } = useEvidenceDownload(`evidencias de ${title}`, evidence);

    const getSubNames = (configAnswer: { id: string, currentNode: number, name: string }[], subCategorytext: string) => {

        //const namesArray = configAnswer.split(',').map(item => item.trim())
        const names = configAnswer.map(item => item.name);

        const result = names.join(" / ");

        const resultWithText = names.length ? `${result} ${subCategorytext.trim().length > 0 ? ` : ${subCategorytext}` : ''}` : subCategorytext.trim().length > 0 ? subCategorytext : ''

        return (
            <Box sx={styles.dropList}>
                <Typography variant="subtitle" fontWeight='600'>{resultWithText}</Typography>
            </Box>
        );
    }


    return (
        <ActionDrawer
            title="EVIDENCIAS"
            body={<>
                <Box sx={styles.mainContainer}>
                    <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                            image: evidences?.images,
                            comment: evidences?.comments,
                            documents: evidences?.documents,
                            video: evidences?.video,
                        }}
                    />
                    <Box>
                        <Button sx={{ marginTop: '5px' }} variant='text_primary' onClick={downloadEvidences} disabled={disable}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                </Box>
            </>}
        >
            {({ openDrawer, open }) => (<>
                <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
                <Grid container rowGap={2} sx={styles.container({ active: open || !!selected, correct: !!selected })}>
                    <Grid item xs={isMultiple ? 12 : 5}>
                        {isCatalog ?
                            <>
                                {fullAnswer?.map(item => (
                                    <Box sx={styles.containerCatalog}>{getSubNames(item.config_answer, item.list_text ?? '')}</Box>
                                ))}
                            </>
                            :
                            <Box sx={styles.info}>
                                {!!iconUrl && <img style={styles.image as CSSProperties} src={iconUrl} alt="icon_multiple" />}
                                <Box sx={styles.questions}>
                                    <Typography variant="subtitle" fontWeight='600' sx={styles.title}>{title} - {score} {!!correctOption && (<span>- {t('Questionarie.fields.correctOption')}</span>)}</Typography>

                                    {!!action?.label && <Typography variant="caption">{t('Questionarie.skipTo', { question: action?.label })}</Typography>}

                                    {!!placeholder && <Typography variant="caption">{placeholder}</Typography>}
                                </Box>
                            </Box>
                        }
                    </Grid>
                    <Actions click={({ name }) => {
                        switch (name) {
                            case AnswerAction.RECOURRENCE_ALERT: {
                                goReportFolioOrActionPlan({ name: 'recurrence', id: ids.residenceAlert })
                                break;
                            }
                            case AnswerAction.REPORT_FOLIO: {
                                goReportFolioOrActionPlan({ name: 'report-folio', id: ids.reportFolio })
                                break;
                            }
                            case AnswerAction.ACTION_PLAN: {
                                goReportFolioOrActionPlan({ name: 'action-plan', id: ids.actionPlan })
                                break;
                            }
                            default: { openDrawer() }
                        }
                    }} isCatalog={isCatalog} haveConfig={haveConfig} correct={!!selected} downloadEvidences={downloadEvidences} disable={disable} />

                </Grid>
            </>)}
        </ActionDrawer>
    )
}

export { Answer }